import $ from 'jquery';

class HighlightToTweet {
    constructor($container) {
        this.$container = $container;

        this.monitorMouseUp();
        this.monitorMouseDown();
        this.monitorSelectionChange();
    }

    monitorMouseUp(e) {
        'use strict';

        const getSelection = this.getSelection;

        this.$container.on('mouseup', function (e) {
            let selection = '';
            let originalSelection = '';
            let url = '';
            let tweetHTML = '';
            let tweetTextLength = '';

            const mouseYpos = e.pageY;
            const mouseXpos = e.pageX;

            if (!$('.tweet-text').length && e.currentTarget.tagName.toLowerCase() !== 'input') {
                selection = getSelection();
                originalSelection = selection;

                if (selection.length) {
                    url = window.location.href;
                    tweetTextLength = 140 - url.length - 3;

                    // If you can add more than five characters to the selection text (after adding the URL)
                    if (tweetTextLength > 5 && (selection.length > tweetTextLength)) {
                        selection = selection.substring(0, tweetTextLength) + '...';
                    }

                    selection = "'" + selection + "'";
                    originalSelection = "'" + originalSelection + "...'";

                    // const twitterUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(selection) + '&url=' + encodeURIComponent(url);
                    const twitterUrl = `//twitter.com/intent/tweet?text=${encodeURIComponent(selection)}&url=${encodeURIComponent(url)}`;
                    const facebookUrl = `//www.facebook.com/sharer/sharer.php?quote=${encodeURIComponent(selection)}&u=${encodeURIComponent(url)}`;

                    const emailUrl = `mailto:?subject=${encodeURIComponent(selection)}&body=${encodeURIComponent(originalSelection)}&nbsp;${encodeURIComponent(url)}`;

                    tweetHTML = `
                    <div class="c-highlight-to-tweet js-highlight-to-tweet-popup" style="top:${mouseYpos}px; left:${mouseXpos}px;">
                        <a class="c-highlight-to-tweet__btn c-highlight-to-tweet__btn--facebook js-social-share" target="_blank" href="${facebookUrl}" title="Share the selected text on Facebook"></a>

                        <a class="c-highlight-to-tweet__btn c-highlight-to-tweet__btn--twitter js-social-share" target="_blank" href="${twitterUrl}" title="Share the selected text on Twitter"></a>
                        <a class="c-highlight-to-tweet__btn c-highlight-to-tweet__btn--email" target="_blank" href="${emailUrl}" title="Share the selected text via email"></a>
                    </div>`;

                    $('body').append(tweetHTML);
                }
            }
        });
    }

    monitorMouseDown(e) {
        this.$container.on('mousedown', function (e) {
            // If the clicked element isn't part of the Tweet popup, remove the Tweet popup
            if (!$(e.currentTarget).parents('.js-highlight-to-tweet-popup').length) {
                $('.js-highlight-to-tweet-popup').remove();
            }
        });
    }

    monitorSelectionChange() {

        const getSelection = this.getSelection;

        // SBTODO: Improve this bug (currently flashes)
        // Bugfix
        // If the selection changes and is empty, remove the popup
        // This bug occurs if you highlight a string, and then click on the highlighted string
        $(document).on('selectionchange', function () {
            const selection = getSelection();

            if (!selection.length) {
                $('.js-highlight-to-tweet-popup').remove();
            }
        });
    }

    getSelection() {
        let selection = '';

        if (window.getSelection) {
            selection = window.getSelection();
        } else if (document.selection) {
            selection = document.selection.createRange();
        }

        selection = selection.toString();

        return selection;
    }
}

export default HighlightToTweet;
